import type { RouteResource } from 'react-resource-router';

import type { UserAccessRights } from '../../common/types/user-access-rights';
import { configuredIntegrationsResource } from '../configured-integrations/resources';
import type { ConfiguredIntegrationsResource } from '../configured-integrations/resources/types';
import { integrationListResource } from '../integration-list/resources';
import type { IntegrationListResource } from '../integration-list/resources/types';
import { userAccessRightsResource } from '../user-access-rights/resources';

export const resources: {
	configuredIntegrationsResource: RouteResource<ConfiguredIntegrationsResource>;
	integrationListResource: RouteResource<IntegrationListResource>;
	userAccessRightsResource: RouteResource<UserAccessRights>;
} = {
	configuredIntegrationsResource,
	integrationListResource,
	userAccessRightsResource,
};
